// extracted by mini-css-extract-plugin
module.exports = {"button":"SizingButton-button-c412"};